import React, { useState } from 'react';
import { Menu, X, Activity } from 'lucide-react';
import Sidebar from './Sidebar';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-surface-50 dark:bg-surface-950 transition-colors duration-500 overflow-hidden">
      {/* Mobile sidebar backdrop with blur */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-surface-950/60 backdrop-blur-sm z-40 lg:hidden animate-fade-in"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar - Fixed on mobile, static on desktop */}
      <aside
        className={`fixed lg:relative inset-y-0 left-0 z-50 w-72 transform transition-all duration-300 ease-in-out lg:translate-x-0 ${sidebarOpen ? 'translate-x-0 shadow-premium-xl' : '-translate-x-full'
          }`}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </aside>

      {/* Main content wrapper */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        {/* Top Header - Glassmorphism */}
        <header className="glass-header px-6 py-4 flex items-center justify-between lg:justify-end">
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 rounded-xl text-surface-500 hover:text-brand-600 hover:bg-brand-50 dark:hover:bg-brand-500/10 transition-all"
          >
            <Menu className="h-6 w-6" />
          </button>

          <div className="flex lg:hidden items-center space-x-3 ml-2">
            <div className="p-2 bg-brand-600 rounded-xl shadow-glow-brand">
              <Activity className="h-5 w-5 text-white" />
            </div>
            <span className="font-bold text-lg tracking-tight dark:text-white">Monitor</span>
          </div>

          {/* User Profile / Quick Actions can go here */}
          <div className="flex items-center space-x-4">
            {/* Empty for now, but ready for expansion */}
          </div>
        </header>

        {/* Scrollable Main Area */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-6 lg:p-10 scrollbar-hide">
          <div className="max-w-7xl mx-auto animate-fade-in">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
